import React from "react";
import { MessageCircle } from "lucide-react";

/** wa.me web intent launcher — no API key needed. Uses last-10-digit + IN country code. */
export default function WhatsAppButton({ phone, message, label = "WhatsApp", size = "sm", testid }) {
  if (!phone) return null;
  const digits = String(phone).replace(/[^\d]/g, "");
  if (digits.length < 10) return null;
  const last10 = digits.slice(-10);
  const url = `https://wa.me/91${last10}?text=${encodeURIComponent(message || "")}`;
  const cls = size === "lg"
    ? "px-4 py-2 text-sm rounded-full"
    : "px-2.5 py-1 text-xs rounded-full";
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
       data-testid={testid || "whatsapp-btn"}
       className={`${cls} inline-flex items-center gap-1.5 font-medium bg-[#25D366] text-white hover:bg-[#1EBE5A] transition-colors`}
       style={{ fontFamily: "Manrope, sans-serif" }}>
      <MessageCircle size={size === "lg" ? 15 : 12} /> {label}
    </a>
  );
}

export function whatsappUrl(phone, message) {
  const digits = String(phone || "").replace(/[^\d]/g, "");
  if (digits.length < 10) return "";
  const last10 = digits.slice(-10);
  return `https://wa.me/91${last10}?text=${encodeURIComponent(message || "")}`;
}
